import React from 'react'
import styled from 'styled-components'
import css from '@styled-system/css'
import { LotusIcon } from 'components_v2/Icons'
import { Box, Flex } from 'ui/acro'

const Ellipse = styled(Box)`
  ${css({
    borderRadius: '50%',
    backgroundColor: '#F2F2F2',
    width: '4.5em',
    height: '4.5em',
    margin: '0 auto'
  })}
`

const LotusEllipse = () => {
  return (
    <Flex width='6em' position='relative' margin='0 auto'>
      <Ellipse />
      <Box position='absolute' bottom='20px'>
        <LotusIcon color='black' />
      </Box>
    </Flex>
  )
}

export default LotusEllipse
